import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, X, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export default function NextStepIndicator() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await api.get("/me/next-step");
      setData(r.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const dismiss = async (e) => {
    e?.stopPropagation();
    setData((d) => (d ? { ...d, dismissed: true } : d));
    setOpen(false);
    try {
      await api.post("/me/next-step/dismiss");
    } catch {}
  };

  const goCta = () => {
    if (data?.cta_url) {
      navigate(data.cta_url);
      dismiss();
    }
  };

  if (loading || !data || data.dismissed) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="next-step-indicator"
        className="relative flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#1B2E7A] text-white text-xs font-medium hover:bg-[#13205A] transition-all overflow-hidden"
      >
        <span className="absolute inset-0 bg-white/10 animate-pulse" aria-hidden />
        <Zap className="h-4 w-4 relative z-10 text-[#F4B81F] drop-shadow" strokeWidth={2.5} />
        <span className="relative z-10 hidden sm:inline">Sugerencia IA</span>
        <span className="relative z-10 inline-flex h-2 w-2 rounded-full bg-[#F4B81F] shadow-md animate-ping" />
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 bg-[#1A1A1A]/40 backdrop-blur-sm flex items-start justify-end p-4 sm:p-6"
          onClick={dismiss}
          data-testid="next-step-modal"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white border border-[#E5E7EB] rounded-md w-full max-w-md p-6 shadow-2xl mt-16 relative"
          >
            <button
              onClick={dismiss}
              className="absolute top-3 right-3 text-[#737373] hover:text-[#1A1A1A]"
              data-testid="next-step-close"
            >
              <X className="h-4 w-4" />
            </button>
            <div className="inline-flex items-center gap-2 mb-3 px-2 py-1 rounded-md bg-[#1B2E7A] text-white text-[10px] font-medium uppercase tracking-[0.2em]">
              <Zap className="h-3.5 w-3.5 text-[#F4B81F]" strokeWidth={2.5} /> Sugerencia con IA
            </div>
            <h3 className="font-heading text-2xl text-[#1A1A1A] mb-2 leading-tight">{data.title}</h3>
            <p className="text-sm text-[#374151] leading-relaxed mb-5">{data.message}</p>
            <button
              onClick={goCta}
              data-testid="next-step-cta"
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-[#1B2E7A] text-white text-sm font-medium hover:bg-[#13205A] transition-colors"
            >
              {data.cta_label || "Ir"}
              <ChevronRight className="h-4 w-4" />
            </button>
            <button
              onClick={dismiss}
              className="w-full text-xs text-[#737373] hover:text-[#1A1A1A] mt-3"
            >
              No por ahora
            </button>
          </div>
        </div>
      )}
    </>
  );
}
